import { ProductFilters } from './product-filters';

export interface ProductFilter {
  name: string;
  selected: boolean;
  display: boolean;
  property: keyof ProductFilters;
  label: string | undefined;
  planCode: string | undefined;
  productCode: string | undefined;
  productCategory: string | undefined;
  sortLevel: number | undefined;
}

export const defaultProductFilterSetup: Omit<ProductFilter, 'name' | 'property'> = {
  selected: false,
  display: true,
  label: undefined,
  planCode: undefined,
  productCode: undefined,
  productCategory: undefined,
  sortLevel: undefined,
};
